<template>
    <div>
        <el-dialog class="sync-tips-dialog" title="提示" :visible.sync="visible" width="350px"
            :before-close="handleClose">
            <div>没有获取到盖章人信息 <el-button style="margin-left: 20px;" @click="auth" type="primary">前往智汇签授权</el-button></div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'addCarDialog',
    props: {},
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        init() {
            this.visible = true
        },
        handleClose() {
            this.visible = false
        },
        auth(){
            this.$emit('auth')
            this.handleClose()
        }
    },
}
</script>
<style lang="less">
.sync-tips-dialog {
    .el-dialog__header{
        padding: 10px 20px;
    }
    .el-dialog__headerbtn {
        top: 15px;
    }
}
</style>
